import { createFastContext, RequestStatusType } from '@rst/libs-ts'
import { Store } from 'effector'
import { RenderBlock } from '../../types'

export type CtxType = {
	$nav: Store<{
		data: RenderBlock.NavigationItem[]
		loading: RequestStatusType
	}>
	$info: Store<{
		data: RenderBlock.Info
		loading: RequestStatusType
	}>
	$head: Store<RenderBlock.InitHead>
	$footer: Store<RenderBlock.InitFooter>
	$lead: Store<RenderBlock.LeadFormData>
}

export const footerCxt = createFastContext<CtxType>()
